module.exports = __webpack_public_path__ + "img/icon_popup_close.3ef50124.png";